import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SignUpHeader from './SignUpHeader';
import APIServices from '../../../services/APIServices';
import { orgNameLimit, selectLoader } from '../../../utils/Helpers';
import { useAuth } from '../../../contexts/AuthContext';

const Questions = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isOwner } = useAuth();
  const userResponse = location.state?.userResponse || []; // Get user responses from previous step
  const [questions, setQuestions] = useState([]);
  const [stepIndex, setStepIndex] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [showOtherInput, setShowOtherInput] = useState(false);
  const [otherInput, setOtherInput] = useState('');
  const [pageLoading, setPageLoading] = useState(true);
  const [responses, setResponses] = useState(userResponse);
  const [isDisabled, setDisabled] = useState(true);
  const [userId, setUserId] = useState('');

  useEffect(() => {
    if (user) {
      // console.log(user._id);
      if (user?.isOnboardingDone) {
        navigate('/projects');
      }
      setUserId(user._id);
    }
  }, [user]);
  useEffect(() => {
    fetchQuestions();
  }, []);

  useEffect(() => {
    if (selectedOptions.length === 0 && !showOtherInput) {
      setDisabled(true);
    } else if (showOtherInput && otherInput.trim().length === 0) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [selectedOptions, otherInput]);

  const fetchQuestions = async () => {
    try {
      const response = await APIServices.get(`/onboarding/questions`);
      // Filter out the "Features" question (since it's already answered)
      const filteredQuestions = response.filter((item) => item.text !== 'What features are important to you?');

      setQuestions(filteredQuestions);
    } catch (error) {
      console.error('Error fetching questions:', error);
    } finally {
      setPageLoading(false);
    }
  };

  const handleOptionClick = (optionId, text, isUserInputOption) => {
    if (!isUserInputOption) {
      if (showOtherInput && otherInput.length > 0) {
        setShowOtherInput(false);
        setOtherInput('');
      }
    } else {
      if (showOtherInput) {
        setOtherInput('');
      }
      setShowOtherInput(!showOtherInput);
    }

    setSelectedOptions((prevSelected) =>
      prevSelected.includes(optionId) ? prevSelected.filter((id) => id !== optionId) : [...prevSelected, optionId]
    );
  };

  const handleContinue = async () => {
    const currentQuestion = questions[stepIndex];
    setShowOtherInput(false);
    if (!currentQuestion) return;

    const responseObj = {
      questionId: currentQuestion._id,
      selectedOptions: selectedOptions,
      userInputText: otherInput || ''
    };

    // Store the response
    setResponses((prev) => [...prev, responseObj]);

    if (stepIndex < questions.length - 1) {
      // Move to next question
      setStepIndex(stepIndex + 1);
      setSelectedOptions([]);
      setOtherInput('');
    } else {
      // All questions answered, submit final responses
      const payload = {
        responses: [...responses, responseObj]
      };

      try {
        console.log(responses);

        const response = await APIServices.put(`/onboarding/user-responses/${userId}`, payload);
        if (response.message) {
          // if (!response?.userSubscription?.subscriptions?.[0]?.isActive && !response?.userSubscription?.subscriptions?.[0]?.subscriptionPlanId && isOwner) {
          //   navigate('/plans'); // Redirect to dashboard or next step
          // } else {
            navigate('/projects');
          // }
        }
      } catch (error) {
        console.error('Error submitting responses:', error);
      }
    }
  };

  return (
    <div className="wrapper welcome-page">
      <div className="main-content">
        <SignUpHeader userName={user.fullName} />
        {pageLoading ? (
          <div className="nodata-loader">{selectLoader(70)}</div>
        ) : (
          <div className="feature-sec question-sec">
            <div className="container">
              <p>{questions[stepIndex]?.text}</p>
              <div className="row align-content-center justify-content-center">
                <div className="col-lg-10">
                  <div className="question-tab-cover">
                    {questions[stepIndex]?.options.map(({ _id, text, isUserInputOption }) => (
                      <a
                        key={_id}
                        href="#"
                        className={`question-tab ${selectedOptions.includes(_id) ? 'question-tab-active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleOptionClick(_id, text, isUserInputOption);
                        }}>
                        {text}
                      </a>
                    ))}
                  </div>
                </div>
              </div>

              {/* Show input field only when "Other" is selected */}
              {showOtherInput && (
                <div className="row">
                  <div className="col-lg-12">
                    <div className="input-group">
                      <input
                        maxLength={orgNameLimit}
                        type="text"
                        className="form-control question-input"
                        placeholder="Please specify"
                        value={otherInput}
                        onChange={(e) => setOtherInput(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              )}

              <button
                className={`btn-black ${isDisabled ? 'disabled-button' : ''} `}
                type="button"
                onClick={handleContinue}
                disabled={isDisabled || (showOtherInput && otherInput.trim().length === 0)}>
                {stepIndex < questions.length - 1 ? 'Continue' : 'Finish'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Questions;
